module.exports = __webpack_public_path__ + "static/media/Pause.a9a0bdc3.svg";